import React from 'react';
import cx from 'classnames';

import { useNavContext } from './NavigationContext';

import styles from './NavigationFooter.module.scss';

export interface NavigationFooterProps {
  /** Content for the `Navigation.Footer`.  */
  children?: React.ReactNode;
  /** Apply CSS class to the container. */
  className?: Parameters<typeof cx>[0];
  /** Icon that appears after the footer's content. */
  icon?: React.ReactNode;
}

export const NavigationFooter: React.FC<NavigationFooterProps> = ({
  children,
  className,
  icon,
}) => {
  const { isCollapsed } = useNavContext();
  return (
    <div
      className={cx(
        styles.navFooter,
        icon && styles.hasIcon,
        isCollapsed && styles.isCollapsed,
        className,
      )}
    >
      <div>{children}</div>
      {icon && !isCollapsed && (
        <div className={cx(styles.iconContainer)}>{icon}</div>
      )}
    </div>
  );
};

export default NavigationFooter;
export { styles };
